import React, { Component } from 'react';
import { connect } from 'react-redux';
import { popupDispatcher, popupState, siteSettingsState, identityState, combineStates, showConfigureDispatcher, combineDispatchers, messageDispatcher } from '../../../../store';
import { ActionPanel, SvgImage, ProductPrice, Checkbox, PopupMessage, PopupType, BusyContainer } from '../../../../components';
import { translate } from '../../../../services';
import { PropTypes } from 'prop-types';
import { translateProperty } from '../../../../util';
import { warningIcon1, errorIcon, wrenchesIcon, warningIcon, readyAssemblyWaningIcon } from '../../../../../style/images';
import { last } from 'lodash';
import { styled } from '@mui/material';
import { Toggle } from '../../../../components/ToggleSwitch';
import { FGcomponent } from './FGcomponent';
import classNames from 'classnames';

export class FooterComponent extends Component {

  constructor() {
    super();
    this.state = {
      showRequiredVariablesMsg: false,
      countToShowReqVariablesMsg: 0,
      selectedOption: 'YES' 
    };
  }

  componentDidUpdate(){
    const { requiredUnselectedVariables } = this.props;
    //condition to setState to show warning popup once
    if(requiredUnselectedVariables.length && !this.state.showRequiredVariablesMsg) {
      this.setState((prevState) => ({
        showRequiredVariablesMsg:true,
        countToShowReqVariablesMsg: prevState.countToShowReqVariablesMsg + 1
      }));
  } 
  //condition to setState to default if requiredUnselectedVariables is 0 after userSelection
  else if(requiredUnselectedVariables.length === 0 && this.state.showRequiredVariablesMsg) {    
    this.setState((prevState) => ({
      showRequiredVariablesMsg:false,
      countToShowReqVariablesMsg: 0
    }));
  } 
  //condition to setState of countToShowReqVariablesMsg to 0 to hide warning popup
  else if(this.state.countToShowReqVariablesMsg === 1 && this.state.showRequiredVariablesMsg) {
    this.setState((prevState) => ({
      countToShowReqVariablesMsg: 0
    }));   
  }

  }

  renderUnselectedVariablesMessage() {
    const { requiredUnselectedVariables } = this.props;
    let message = null;

    if( requiredUnselectedVariables.length && this.state.showRequiredVariablesMsg ) {
      const variableNames = requiredUnselectedVariables.map( variable => translateProperty( variable.properties, variable.title ) ).join( ', ' );
      message = <span className="warning-message">
        <SvgImage source={ warningIcon1 }/>
        { 
          translate( 
            'Please select mandatory {tr:item}: {variables}', 
            { item: requiredUnselectedVariables.length === 1 ? 'item' : 'items', variables: variableNames } 
          )
        }
      </span>; 
      // this.props.addMessage( { timeout: 10000, messageType: 'warning', messageText: translate( 
      //   'Please select mandatory {tr:item}: {variables}', 
      //   { item: requiredUnselectedVariables.length === 1 ? 'item' : 'items', variables: variableNames } 
      // ) } );
    }

    return <div className={classNames("configuration-message",{"configurator-page-message-container":message})}>
    { message }
  </div>;
  }

  renderMessage() {
    const { invalidVariables, requiredUnselectedVariables ,configuration,isValidConfiguration} = this.props;
    let message = null;
    if(isValidConfiguration!=undefined && !isValidConfiguration){
     message= <span className="error-message">
     <SvgImage source={ errorIcon } />
     { translate( 'INVALID_CONFIGURATION' ) }
   </span>;
    }
    else if( invalidVariables.length && requiredUnselectedVariables.length ) {
      message = <span className="error-message">
        <SvgImage source={ errorIcon }/>
        { translate( 'The configuration is invalid, please correct the highlighted selections' ) }
      </span>;
      // this.props.addMessage( { timeout: 10000, messageType: 'error', messageText: translate( 'The configuration is invalid, please correct the highlighted selections' ) } );
    } else if( invalidVariables.length ) {
      const variableNames = invalidVariables.map( variable => translateProperty( variable.properties, variable.title ) ).join( ', ' );
      message = <span className="error-message">
        <SvgImage source={ errorIcon }/>
        { 
          translate( 
            'The configuration is invalid, please correct your {tr:selection} for: {variables}', 
            { selection: invalidVariables.length === 1 ? 'selection' : 'selections', variables: variableNames } 
          ) 
        }
      </span>;
      //  this.props.addMessage( { timeout: 10000, messageType: 'error', messageText: translate( 
      //   'The configuration is invalid, please correct your {tr:selection} for: {variables}', 
      //   { selection: invalidVariables.length === 1 ? 'selection' : 'selections', variables: variableNames } 
      // )  } );
    } else if(configuration && configuration[0] && configuration[0].model && configuration[0].model.children && configuration[0].model.children[0] && configuration[0].model.children[0].variables &&  configuration[0].model.children[0].variables[0]&& configuration[0].model.children[0].variables[0].assignedValue && configuration[0].model.children[0].variables[0].assignedValue.properties?.warningMessage){
      message = <span className="warning-message">
      <SvgImage source={ warningIcon1 }/>
      { 
        translate( 
          this.props?.configuration[0].model?.children[0]?.variables[0]?.assignedValue?.properties?.warningMessage
        )
      }
    </span>; 
    }

    return <div className={classNames("configuration-message",{"configurator-page-message-container":message})}>
      { message }
    </div>;
  }

  onAssemblyChanged = () => {
    this.props.onAssemblyChanged();
  }

  renderReadyAssembly(){
    const { isReadyAssembled, template, siteSettings } = this.props;
    const titleForAssemblyCheckBox =<span><SvgImage source={ wrenchesIcon }/>&nbsp;{translate("Ready Assembly")}</span>;

    if( template.productModelType === 1 && siteSettings.createSupercodeInSap){
      return (
        <div className="assembly-type">
          {/* <Checkbox titleFirst fromConfigurator title={ titleForAssemblyCheckBox  } checked={ isReadyAssembled } onChange={ this.onAssemblyChanged }/> */}
          {titleForAssemblyCheckBox}
          <Toggle
          label={"isReadyAssembled"}
          toggled={isReadyAssembled}
          onClick={this.onAssemblyChanged}
          ></Toggle>
          { isReadyAssembled &&
           <div className='warning-panel'>
           <span className="warning-message" >
            <SvgImage source={ readyAssemblyWaningIcon } className="warning-message-icon"/>
            { translate( "Mounted CBs cannot be given back to ABB" )}
          </span>
          </div> }
        </div>
      )
    }
    return null;
  }

  showConfirmationMessage = () => {
    this.props.setPopup( 
      {
        title: `Warning`,
        component: <PopupMessage
          text={ translate('WARNING_CONFIGURATION_NOT_SAVED') } 
          actionText={ translate( 'Yes' ) } 
          cancelText={ translate( 'No' ) }
          onClick={ () => this.props.hidePopup()}
          popupType={ PopupType.Warning }
        />,
        showHeader: true,
        keepOpen: true 
      } 
    );
  }
  handleOptionChange = ( changeEvent, products ) => {
    this.setState( {
      selectedOption: changeEvent.target.value
    } );

  }
  render() {
    const { fromCart, invalidVariables, isPopup,supercodeAdditionalProduct, showConfiguratorButtonAtTop, isValid, oldProduct, products, requiredUnselectedVariables, template, isReadyAssembled, hasAccessories, supercodeIdentified, assemblyType, user,configuration, isEdit,FG,FGDescription,fromSearch,isValidConfiguration } = this.props;
    const isInvalid = !isValidConfiguration || !isValid || invalidVariables.length > 0 || requiredUnselectedVariables.length > 0;
    //const isInvalid =  invalidVariables.length > 0 || requiredUnselectedVariables.length > 0;
  const apttusReconfig = user.authenticationType === 'Apttus' && user.properties["Action"] === "Reconfig";
    const fromCbol = user.authenticationType === 'Cbol';
    const cartProducts = isPopup ? { ...products, configuration: template } : products;
    const addSettings = { onClick: () => isPopup && this.props.hidePopup(), disabled: isInvalid };
    const atslSettings = {onClick: () => isPopup && this.props.hidePopup(), disabled: isInvalid };
    const FGcode=FG && FG.length>0?FG: '待开';
    const product={...cartProducts, FG:FG};
    const cancelSettings = isPopup && { onClick: () => {
      if(this.props.fromConfigurator){
        this.props.leaveConfigurator();
      }
      else if(last(this.props.popup)?.showConfirmation) {
        this.showConfirmationMessage();
      } else this.props.hidePopup();
    }};
    const exportSettings = { onClick: () => isPopup && this.props.hidePopup(), disabled: isInvalid, fromCbol: fromCbol, showExport: this.props.siteSettings.showExportOptions };
    const superCodeSettings = false && this.props.user.useLocalCart && isReadyAssembled && isPopup && 
      { onClick: () => isPopup && this.props.hidePopup(), disabled: isInvalid || !hasAccessories }
    return <><div className={ "footer-item " + this.props.customClassName }>      
      <div className="message-area" style={showConfiguratorButtonAtTop ? {width: "55%"}:{}}>
      { this.renderReadyAssembly() }
      { this.renderMessage() }
      { this.renderUnselectedVariablesMessage() }
      </div>
      <div className="actions" style={showConfiguratorButtonAtTop ? {width: "40%", flexDirection: "column"}:{}}>
        {/* <ProductPrice translationPhrase={ 'Total_' } showConfiguratorButtonAtTop={ showConfiguratorButtonAtTop } fromConfigFooter fromCart={ false || fromCbol || apttusReconfig } priceSize='big' product={product } fromSearch={fromSearch} /> */}
        <div>
    <ActionPanel
          add={ addSettings } 
          isPopup={ isPopup } 
          fromCart={ fromCart } 
          cancel={ cancelSettings } 
          exportOptions={exportSettings}
            product={ product }
          oldProduct={ oldProduct }
          isReadyAssembled = { isReadyAssembled && hasAccessories }
          assemblyType = { assemblyType }
          superCodeOptions = { superCodeSettings }
          supercodeIdentified = { supercodeIdentified }
          supercodeAdditionalProduct = {supercodeAdditionalProduct}
          atsl = { atslSettings }
          className={showConfiguratorButtonAtTop ? "width100per" : ""}
            deliveryOption={ this.props.selectedOption }
            fromConfigFooter
            onConfigure={true}
            FG={FGcode}
          fromConfigurator={this.props.fromConfigurator}
          toggleConfirmation={this.props.toggleConfirmation}
          hasAccessories = {this.props.hasAccessories}
          fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
          isEdit={isEdit}
          />
      </div>
      </div>
    </div>

    </>
  }
}

FooterComponent.propTypes = {
  fromCart: PropTypes.bool,
  hidePopup: PropTypes.func.isRequired, 
  invalidVariables: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  isPopup: PropTypes.bool, 
  isValid: PropTypes.bool, 
  oldProduct: PropTypes.shape( {} ), 
  products: PropTypes.oneOfType( [PropTypes.array, PropTypes.object] ), 
  requiredUnselectedVariables: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  template: PropTypes.shape( {
    validityInfo: PropTypes.shape( {
      isValid: PropTypes.bool,
      message: PropTypes.string
    } ),
    productModelType: PropTypes.number
  } ),
  onAssemblyChanged: PropTypes.func.isRequired,
  isReadyAssembled: PropTypes.bool,
  hasAccessories: PropTypes.bool
};

export const Footer = connect( combineStates( popupState, siteSettingsState, identityState ), combineDispatchers(popupDispatcher, showConfigureDispatcher, messageDispatcher) )( FooterComponent );